import axiosInstance from 'Shared/utilities/axiosInstance';
import { getAxiosConfig, getUrlFromUri, handleResponse, withCancellation } from 'Shared/utilities/fetchHelpers';
import { Either, isRight } from 'fp-ts/lib/Either';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { QuarantineActionType, setLoading } from '../ducks/quarantine';

function* fetchQuarantineMessagesFromApi(): Generator<any, void, Either<Error, any>> {
  try {
    yield put(setLoading(true));

    const result = yield call(() =>
      withCancellation(cancelToken =>
        axiosInstance.get('/api/documents/v1/retrieveQuarantineMessages', {
          ...getAxiosConfig(cancelToken),
        })
      ).then(handleResponse)
    );

    if (isRight(result)) {
      const messages = result.right.map((message: any) => {
        const udpMetaData = message.udpMetaData ? JSON.parse(message.udpMetaData) : {};

        return {
          policyNumber: udpMetaData.policyNumber || null,
          accountNumber: udpMetaData.accountNumber || null,
          uploadDate: message.lastUpdatedTimeStamp || '',
          fileName: udpMetaData.fileName || 'Unnamed File',
          contentId: message.contentId || '',
        };
      });

      yield put({
        type: QuarantineActionType.SET_QUARANTINE_MESSAGES,
        payload: {messages},
      });
    }
  } catch (error) {
    console.error('Error fetching quarantine messages:', error);
    yield put({
      type: QuarantineActionType.SET_QUARANTINE_MESSAGES,
      payload: {messages: []},
    });
  } finally {
    yield put(setLoading(false));
  }
}

function* acknowledgeQuarantineMessageInApi(action: any): Generator<any, void, Either<Error, any>> {
  try {
    yield put(setLoading(true));

    const result = yield call(() =>
      withCancellation(cancelToken =>
        axiosInstance.put(getUrlFromUri('/api/documents/v1/isAcknowledged'), null, {
          ...getAxiosConfig(cancelToken),
          headers: {
            ...getAxiosConfig(cancelToken).headers,
            contentId: action.payload.contentId,
          },
        })
      ).then(handleResponse)
    );

    if (isRight(result)) {
      yield put({
        type: QuarantineActionType.CLEAR_QUARANTINE_MESSAGE,
        payload: {contentId: action.payload.contentId},
      });
    }
  } catch (error) {
  } finally {
    yield put(setLoading(false));
  }
}

export default function* quarantineSaga() {
  yield all([
    takeLatest(QuarantineActionType.FETCH_QUARANTINE_MESSAGES, fetchQuarantineMessagesFromApi),
    takeLatest(QuarantineActionType.ACKNOWLEDGE_QUARANTINE_MESSAGE, acknowledgeQuarantineMessageInApi),
  ]);
}
